import type { SuggestionChip } from "../../lib/pro-chat-suggestions";

export function SuggestionChips({
  chips,
  onSelect,
}: {
  chips: SuggestionChip[];
  onSelect: (prompt: string) => void;
}) {
  return (
    <div
      data-testid="copilot-suggestion-chips"
      className="flex flex-col items-stretch gap-2"
    >
      {chips.map((chip) => (
        <button
          key={chip.id}
          type="button"
          onClick={() => onSelect(chip.prompt)}
          className="min-h-11 rounded-full border border-border bg-card px-4 py-2 text-left text-sm text-fg hover:bg-muted"
        >
          {chip.label}
        </button>
      ))}
    </div>
  );
}
